import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link';

import {ariaLabels, testAttributes} from './Constants';
import {authorBylineContainer, authorPrefix, authorByLineTooltipTrigger} from './AuthorByline.module.scss';

export default function AuthorByline({ author = undefined, prefix, url = undefined, renderTooltip = undefined })
{
    return (
        <div data-testid={testAttributes.AUTHOR_BY_CONTAINER} className={authorBylineContainer}  >
            <span
                data-testid={`${testAttributes.AUTHOR_BY_LABEL}${prefix.replace(/\s+/g, '')}`}
                className={authorPrefix}
            >
                {prefix}
            </span>

            {renderTooltip
                ? renderTooltip(
                    <span
                        aria-label={ariaLabels.AUTHOR_LINK}
                        className={authorByLineTooltipTrigger}
                        key={ariaLabels.AUTHOR_LINK}
                    >
                        {author}
                    </span>
                )
                : <Link aria-label={ariaLabels.AUTHOR_LINK} href={url} key={ariaLabels.AUTHOR_LINK}>{author}</Link>
            }
        </div>
    )
}

AuthorByline.propTypes = {
    /** children, Author's review ( required ) */
    author: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    /** prefix, Author's prefix description ( required ) */
    prefix: PropTypes.string.isRequired,
    /** URL, Author's url profile */
    url: PropTypes.string,
    /** renderTooltip, renders Author's tooltip ( optional ) */
    renderTooltip: PropTypes.func,
};
